/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "UpdateApplicationFlowRequest": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateApplicationFlowResponse": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateApplicationFlowRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateApplicationFlowRequest @ squareup/corporate_card/service/update_application_flow.proto at 10:1
 */
export const UpdateApplicationFlowRequest = $root.lookupType('squareup.corporate_card.service.UpdateApplicationFlowRequest');
fixType(UpdateApplicationFlowRequest, {
  applicationFlow: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateApplicationFlowRequest);
/**
 * SOURCE UpdateApplicationFlowResponse @ squareup/corporate_card/service/update_application_flow.proto at 19:1
 */
export const UpdateApplicationFlowResponse = $root.lookupType('squareup.corporate_card.service.UpdateApplicationFlowResponse');
fixType(UpdateApplicationFlowResponse);
Builder.createAndAttachToType(UpdateApplicationFlowResponse);